import { RootState } from 'editor/src/store/index';

import getGalleryImagesCount from './getGalleryImagesCount';
import getGalleryUploadedImagesCount from './getGalleryUploadedImagesCount';

const areAllImagesUploaded = (state: RootState) =>
  getGalleryUploadedImagesCount(state) === getGalleryImagesCount(state);

export default areAllImagesUploaded;
